module.exports = __webpack_public_path__ + "static/media/bullet_icon.7a7076b9.svg";